import React from "react"
import { Grid, IconButton, Paper } from "@material-ui/core"
import { SimpleSelectOqt } from "../controls";
import { useFormik } from "formik";
import { DeleteIcon } from "./icons";
import { Transformador } from "./Transformador";

const operadores = [
  {label: "Igual", value: "IGUAL"},
  {label: "Distinto", value: "DISTINTO"},
  {label: "Menor", value: "MENOR"},
  {label: "Mayor", value: "MAYOR"},
  {label: "Menor o igual", value: "MENORIGUAL"},
  {label: "Mayor o igual", value: "MAYORIGUAL"},
  {label: "Comienza", value: "COMIENZA"},
  {label: "Finaliza", value: "FINALIZA"},
  {label: "Contiene", value: "CONTIENE"},
]

export const Condicion = ({transformador1, transformador2, operacion, grupo, onChange, onRemove}) => {

  
  const fmk = useFormik({
    initialValues: {transformador1, transformador2, operacion, grupo},
    onSubmit: values => {
      onChange(values)
    }
  })

  const handleChangeValue = (name, value) => {
    fmk.setFieldValue(name, value);
    fmk.submitForm()
  }

  const handleRemoveClick = () => {
    onRemove && onRemove();
  }

  return (
    <>
      <Paper elevation={1} style={{margin: 8, padding: 8}}>
        <Grid container>
          <Grid item xs={4}>
            <Transformador {...transformador1} onChange={(values)=>handleChangeValue("transformador1", values)} tiposTransformaciones={[{label: "Fórmula", value: 'FORMULA'}]}/>
          </Grid>
          <Grid item xs={3} style={{paddingLeft: 8, paddingRight: 8}}>
            <SimpleSelectOqt name="operacion" optionsList={operadores} formik={fmk} variant="standard" caption="Seleccione una operación" 
            rootStyle={{
              margin: 0, 
              marginLeft: 0,
              width: "100%",
              border: "1px #cccccc solid",
              padding: "0px 4px 0px 4px",

            }}/>
          </Grid>
          <Grid item xs={4}>
            <Transformador {...transformador2} onChange={(values)=>handleChangeValue("transformador2", values)} tiposTransformaciones={[{label: "Fórmula", value: 'FORMULA'}]}/>
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={handleRemoveClick}><DeleteIcon style={{fill: "#d53e3e"}}/></IconButton>
          </Grid>
        </Grid>
      </Paper>  
    </>
  )
  
}

